import * as React from "react";
const SvgPerplexity = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "#303030" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.95721 3.59375L9.61428 6.96546V3.60153H10.3262V6.98054L13.9996 3.59375V7.43799H15.5078V12.983H14.0043V16.4061L10.3262 13.1724V16.4432H9.61428V13.2258L5.96136 16.4453V12.983H4.45312V7.43799H5.95721V3.59375ZM9.0776 8.14166H5.16501V12.2793H5.96046V10.9741L9.0776 8.14166ZM6.67321 11.2863V14.8751L9.61428 12.283V8.61322L6.67321 11.2863ZM10.3467 12.2487V8.60976L13.2886 11.2831V12.983H13.2924V14.8385L10.3467 12.2487ZM14.0043 12.2793H14.7959V8.14166H10.9125L14.0043 10.9448V12.2793ZM13.2877 7.43799V5.21233L10.8737 7.43799H13.2877ZM9.08313 7.43799H6.6691V5.21233L9.08313 7.43799Z",
      fill: "white"
    }
  )
);
export default SvgPerplexity;
